import { InvitacionPostulacion } from '../models/invitaciones.models';

export const INVITACIONES_MOCK: InvitacionPostulacion[] = [
  {
    id: 'INV-0001',
    idPostulacion: 'P-1020',
    concurso: 'FONDECYT Regular',
    proyecto: 'Dinamicas de innovacion territorial',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500120',
    rolDestino: 'postulante',
    tipoParticipacion: 'Coinvestigador',
    nombresDestino: 'Camilo',
    apellidosDestino: 'Garcia',
    emailDestino: 'cgarcia@uchile.cl',
    estadoRespuesta: 'pendiente',
    asociadaAlProceso: false,
  },
  {
    id: 'INV-0002',
    idPostulacion: 'P-1021',
    concurso: 'FONIS 2026',
    proyecto: 'Salud digital para atencion primaria',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500121',
    rolDestino: 'postulante',
    tipoParticipacion: 'Director adjunto',
    nombresDestino: 'Camilo',
    apellidosDestino: 'Garcia',
    emailDestino: 'cgarcia@uchile.cl',
    estadoRespuesta: 'aceptada',
    asociadaAlProceso: true,
  },
  {
    id: 'INV-0003',
    idPostulacion: 'P-1022',
    concurso: 'Redes de Investigacion 2026',
    proyecto: 'Cooperacion avanzada en inteligencia ambiental',
    subdireccion: 'REDES Y ESTRATEGIA',
    folio: '500122',
    rolDestino: 'postulante',
    tipoParticipacion: 'Investigador patrocinante',
    nombresDestino: 'Camilo',
    apellidosDestino: 'Garcia',
    emailDestino: 'cgarcia@uchile.cl',
    estadoRespuesta: 'rechazada',
    asociadaAlProceso: false,
  },
  {
    id: 'INV-1001',
    idPostulacion: 'P-1010',
    concurso: 'Programa I+D Regional',
    proyecto: 'Biotecnologia aplicada a la agricultura',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500094',
    rolDestino: 'ayudante_postulante',
    nombresDestino: 'Camila',
    apellidosDestino: 'Garcia',
    emailDestino: 'cgarcia@uchile.cl',
    estadoRespuesta: 'pendiente',
    asociadaAlProceso: false,
  },
  {
    id: 'INV-1002',
    idPostulacion: 'P-1003',
    concurso: 'Capital Humano',
    proyecto: 'Becas doctorado en IA aplicada',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500012',
    rolDestino: 'ayudante_postulante',
    nombresDestino: 'Camila',
    apellidosDestino: 'Garcia',
    emailDestino: 'cgarcia@uchile.cl',
    estadoRespuesta: 'aceptada',
    asociadaAlProceso: true,
  },
  {
    id: 'INV-2001',
    idPostulacion: 'P-1001',
    concurso: 'Proyectos de Investigacion',
    proyecto: 'Optimizacion de sistemas de riego inteligente',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500001',
    rolDestino: 'colaborador',
    estadoRespuesta: 'pendiente',
    asociadaAlProceso: false,
  },
  {
    id: 'INV-2002',
    idPostulacion: 'P-1003',
    concurso: 'Capital Humano',
    proyecto: 'Becas doctorado en IA aplicada',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500012',
    rolDestino: 'colaborador',
    estadoRespuesta: 'rechazada',
    asociadaAlProceso: false,
  },
  {
    id: 'INV-2003',
    idPostulacion: 'P-1011',
    concurso: 'Desarrollo Tecnologico Territorial',
    proyecto: 'Soluciones logisticas para cadena de frio',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500103',
    rolDestino: 'colaborador',
    estadoRespuesta: 'aceptada',
    asociadaAlProceso: true,
  },
  {
    id: 'INV-3001',
    idPostulacion: 'P-1005',
    concurso: 'Programa I+D Regional',
    proyecto: 'Laboratorio de manufactura avanzada',
    subdireccion: 'INVESTIGACION APLICADA',
    folio: '500041',
    rolDestino: 'recomendador',
    estadoRespuesta: 'pendiente',
    asociadaAlProceso: false,
    cartaGuardada: false,
    cartaEnviada: false,
  },
  {
    id: 'INV-3002',
    idPostulacion: 'P-1008',
    concurso: 'Capital Humano',
    proyecto: 'Especializacion en bioinformatica clinica',
    subdireccion: 'CAPITAL HUMANO',
    folio: '500072',
    rolDestino: 'recomendador',
    estadoRespuesta: 'pendiente',
    asociadaAlProceso: false,
    cartaGuardada: true,
    cartaEnviada: false,
    recomendacion: {
      resumen: 'La postulante destaca por su proyeccion academica y compromiso con la investigacion aplicada.',
      fortalezas: 'Trayectoria consistente, alta motivacion y experiencia previa en proyectos competitivos.',
      recomendacionFinal: '',
    },
  },
];
